import { render } from "./ChivaMap.vue?vue&type=template&id=22b6d39d"
import script from "./ChivaMap.vue?vue&type=script&lang=js"
export * from "./ChivaMap.vue?vue&type=script&lang=js"

import "./ChivaMap.vue?vue&type=style&index=0&id=22b6d39d&lang=css"
script.render = render

export default script